// Copyright (c) Docugami, Inc. All rights reserved.

// This file contains utility functions that are used by dgmlSlice.ts
// It exists to break a circular dependency chain:
// frontendSlice -> dgmlSlice -> dgmlSelectors -> frontend/selectors -> frontendSlice

import { createDefaultMappedTokens, createMappedTokens } from "utils/MappedTokens";
import { TextEditOperation } from "./dgmlTypes";

export const createMappedTokensForEdits = (edits?: TextEditOperation[]) => {
    if (!edits?.length) {
        return createDefaultMappedTokens();
    }
    else {
        let tokenKeys: string[] = Array.from(Array(edits[0].totalTokenCount - edits[0].tokenCountDelta + 1), (e, i) => `k${i}`)
        for (const edit of edits) {
            const removedTokens = [...edit.removedTokens].sort((a, b) => b.index - a.index);
            for (const removed of removedTokens) {
                tokenKeys.splice(removed.index, 1);
            }

            for (const added of edit.addedTokens) {
                tokenKeys.splice(added.index, 0, added.key);
            }
        }

        return createMappedTokens(tokenKeys);
    }
}
